import React from "react";
import { ProductPrice, ProductTile as TProductTile } from "~/types/product";
import ProductTile from "../ProductTile";
import keyBy from "lodash/keyBy";

type Props = {
  relatedProductPrices?: Promise<ProductPrice[] | null>;
  relatedProducts: TProductTile[];
};

const ProductRelated: React.FC<Props> = ({
  relatedProducts,
  relatedProductPrices,
}) => {
  const [prices, setPrices] = React.useState<
    Record<string, ProductPrice> | undefined
  >();

  React.useEffect(() => {
    if (!relatedProductPrices) return;
    Promise.resolve(relatedProductPrices).then((prices) => {
      setPrices(keyBy(prices, "id") ?? {});
    });
  }, [relatedProductPrices]);

  if (!relatedProducts || relatedProducts.length === 0) {
    return null;
  }

  return (
    <div
      aria-label="Similar Products"
      className="related py-8"
    >
      <h2 className="related__heading mb-6 font-serif text-[1.375rem] font-bold text-blue900">
        Similar Products
      </h2>
      <div className="related__products grid grid-cols-2 gap-x-2 gap-y-4 xsm:grid-cols-3 mmd:grid-cols-4 lg:grid-cols-6">
        {relatedProducts.map((product, index) => (
          <ProductTile
            key={index}
            name={product.name}
            path={product.path}
            millLogo={product.millLogo}
            mainImage={product.mainImage}
            variantImages={product.variantImages}
            price={prices?.[product.id]?.price}
            callout={prices?.[product.id]?.callout}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductRelated;
